<div id="attribute">
    <div class="title-head" fxLayout="row" fxLayoutAlign="space-between center" color="primary">
        <span>
            Copy Layout
        </span>
        <button [attr.guide]="'copy-template-btn-1' + '__' + sanitizedUrl" mat-icon-button>
            <mat-icon (click)="close()">
                close
            </mat-icon>
        </button>
    </div>
    <div class="padding-11" style="overflow-x: auto;">
        <div [formGroup]="firstFormGroup" fxLayout="column">

            <mat-form-field fxFlex="50" appearance="outline">
                <mat-label>Select Pages To be Copied</mat-label>

                <mat-select [disableOptionCentering]="true" #singleSelect formControlName="uuid" autocomplete="off">
                    <mat-option>
                        <ngx-mat-select-search name="SelectPages Search" ngDefaultControl
                            [formControl]="cmsFilterControl" placeholderLabel="Search"
                            [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let opt of filteredCmsTypeList; let i=index;" 
                    [value]="opt.uuid">
                        {{opt.title}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="firstFormGroup.controls.uuid.errors?.required">
                    Please fill out this field.
                </mat-error>

            </mat-form-field>

        </div>
        <div class="padding-top10 " fxLayoutGap="10px">


            <button [attr.guide]="'copy-template-btn-2' + '__' + sanitizedUrl" (click)="duplicate()" [disabled]="text != 'Save'" mat-raised-button>
                {{ text }}
                <mat-icon *ngIf="text != 'Save'">
                    <mat-spinner color="primary" diameter="20"> </mat-spinner>
                </mat-icon>
            </button>
        </div>

    </div>
</div>